export const getChatbotAllowedClients = (): number[] => {
  return JSON.parse(
    ((import.meta.env || process.env).VITE_CHATBOT_ALLOWED_CLIENTS as string) ||
      '[]'
  ) as number[];
};
